import type { ChromeCopy } from './types'

export const bn: ChromeCopy = {
  appName: 'সমঝো',
  tagline: 'কাগজ বুঝুন। এরপর কী করবেন, জেনে নিন।',
  savedTitle: 'সেভ করা কাগজ',
  upcomingTitle: 'আসন্ন শেষ তারিখ',
  markDone: 'কাজ হয়ে গেছে',
  doneLabel: 'হয়ে গেছে',
  deadlineCheckIn: '{n}টি সেভ করা কাগজের শেষ তারিখ কাছে। কাজ হয়েছে?',
  savedHint: 'এগুলো শুধু এই ফোনেই আছে। কাগজের ছবি আর পুরো লেখা কখনও সেভ হয় না — শুধু দরকারি তথ্য।',
  emptySaved: 'এখনও কোনো কাগজ সেভ করা হয়নি।',
  clearAll: 'সব মুছে দিন',
  deleteItem: 'মুছুন',
  aboutTitle: 'গোপনীয়তা আর দরকারি তথ্য',
  privacyPoints: [
    'আপনার কাগজের ছবি আর তাতে লেখা কথা এই ফোনেই পড়া হয় আর বুঝিয়ে বলা হয়। ছবিটা কোথাও আপলোড হয় না।',
    'আপনি "সেভ করুন" না টিপলে কিছুই সেভ হয় না। "নতুন কাগজ" টিপলেই আগের কাগজটা স্ক্রিন আর মেমোরি থেকে মুছে যায়।',
    'সেভ করলে শুধু দরকারি তথ্য (তারিখ, টাকার অঙ্ক, নম্বর) রাখা হয়, শুধু এই ফোনেই — ছবি বা পুরো লেখা নয়। আপনি যেকোনো সময় এগুলো মুছে দিতে পারেন।',
    'ইন্টারনেট শুধু তিনটে কাজে লাগে: প্রথমবার পড়ার টুলটা আর আওয়াজগুলো (সমঝোর নিজের সাইট থেকে) ডাউনলোড করতে, আর — শুধু আপনি চাইলে — কাগজের ইংরেজি লাইনগুলো অনুবাদ করতে। অনুবাদের জন্য পাঠানো লাইনগুলো সেভ করা হয় না, আর আধার ও ফোনের মতো নম্বর আগেই সরিয়ে দেওয়া হয়। তৃতীয়ত — শুধু আপনি প্রশ্ন করলে: উত্তর লেখার জন্য কাগজের লেখা আর আপনার প্রশ্ন সমঝোর সার্ভার আর একটি AI পরিষেবায় (Groq) যায়, আধার, প্যান, ফোন আর ইমেল আগে সরিয়ে; শুধু সরকারি ওয়েবসাইট দেখা হয়, আর কিছুই সেভ করা হয় না। যে লাইনগুলো ইংরেজিতে নয়, সেগুলো একটি AI পরিষেবা (Groq) অনুবাদ করে।',
    'সমঝোতে কোনো বিজ্ঞাপন নেই। আমরা শুধু গুনি কতজন অ্যাপটা খোলেন (Cloudflare Web Analytics, কোনো কুকি ছাড়া)। আপনার কাগজের কিছুই তাতে থাকে না, আর কাগজের লেখা কখনও লগ করা হয় না।'
  ],
  disclaimerTitle: 'এটা সরকারি বা আইনি পরামর্শ নয়',
  disclaimer: 'সমঝো একটা স্বাধীন সাহায্যের টুল, সরকারি ওয়েবসাইট নয়। এটা আপনার কাগজ সহজ করে বুঝিয়ে দেয়, কিন্তু এর ব্যাখ্যা সরকারি বা আইনি ব্যাখ্যা নয়। দরকারি কথাগুলো সবসময় আসল কাগজ বা যে দপ্তর কাগজটা দিয়েছে, তাদের সঙ্গে মিলিয়ে নিন।',
  contactTitle: 'কোনো সমস্যা হচ্ছে?',
  contact: 'কোনো সমস্যা হলে আমাদের সঙ্গে এখানে যোগাযোগ করুন:',
  freeTitle: 'একদম বিনামূল্যে',
  free: 'সমঝো ওপেন-সোর্স টুল দিয়ে চলে: পড়ার জন্য Tesseract, আর শোনানোর জন্য আপনার ফোনের নিজের আওয়াজ বা Meta-র ওপেন MMS আওয়াজ (CC BY-NC 4.0)। কোনো অ্যাকাউন্ট লাগে না, কোনো টাকা লাগে না।',
  shareApp: 'WhatsApp-এ শেয়ার করুন',
  installApp: 'অ্যাপটা ফোনে যোগ করুন',
  offline: 'আপনি অফলাইনে আছেন',
  offlineHint: 'আগে সমঝো ব্যবহার করে থাকলে ইন্টারনেট ছাড়াও কাগজ পড়া যাবে।',
  shareAppMessage: 'সরকারি কাগজ সহজ ভাষায় বুঝতে আর শুনতে SAMJHO ব্যবহার করুন (বিনামূল্যে):\nhttps://samjho.pages.dev'
}
